import "../../css/Panel.css";
import "../../css/Patient.css";
import "../../css/PatientSearch.css";
import "../../css/custom-datatable.css";
import "../../css/Dashboard.css";
import { DashboardStorePanel } from "../../components/DashboardStorePanel";
import { useEffect, useState } from "react";

export default function DashboardStore({
  show,
  openCashPopup,
  createPopupQuestion,
  removePopupQuestion,
}) {
  // Se monta la primera vez que se muestra y después solo se oculta,
  // para conservar su estado al navegar a otras pantallas
  const [mounted, setMounted] = useState(show);

  useEffect(() => {
    if (show) setMounted(true);
  }, [show]);

  if (!show && !mounted) {
    return <></>;
  }

  return (
    <div
      className="patient-data"
      style={show ? undefined : { display: "none" }}
    >
      <div className="patient-data-header">
        <span className="header-text">Inteligencia de negocio - Almacén</span>
      </div>
      <div
        className="patient-data-content dashboard-content"
        style={{ paddingBottom: 20 }}
      >
        <div className="action-bar">
          <div className="action-bar-resume">
            <span>Inteligencia de negocio</span>
            <span>|</span>
            <span className="signed-text">Almacén</span>
          </div>
        </div>
        <div className="dashboard-content">
          <DashboardStorePanel
            createPopupQuestion={createPopupQuestion}
            removePopupQuestion={removePopupQuestion}
            openCashPopup={(
              selectedOpticId,
              type,
              show,
              startDate,
              endDate,
              seeMore,
              opticName,
              agentId,
            ) =>
              openCashPopup(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              )
            }
          />
        </div>
      </div>
    </div>
  );
}
